const appSocial = angular.module('social', ['custom-select', 'echarts']);
